<div class="px-16 py-10  rounded-3xl uploader-status flex flex-col items-center justify-center align-middle">

  <img src="/assets/img/confirmation.png">
  <div class="py-6 text-lg font-semibold text-center">{{data.message}}</div>
  <button type="button" mat-dialog-close="true"
    class="mt-4 w-1/2 font-semibold text-white bg-aguacate-green hover:bg-aguacate-green-700 focus:ring-4 focus:outline-none focus:ring-primary-300 text-lg rounded-lg px-5 py-2.5 text-center">
    {{ data.button }}
  </button>
</div>
